<template>
  <div class="c-stats-row">
    <div class="wrapper">
      <div class="left-column">
        <div class="my-box-wrapper">
          <div class="my-box">
            <div class="my-box-header">
              <span :class="{ 'text-muted': totalsLoading }">{{ title }}</span>
            </div>
            <div class="my-box-body">
              <span
                :style="[ totalsLoading ? { color: '#777' } : { color }]"
              >
                {{ total }}
              </span>
            </div>
            <c-spinner v-if="totalsLoading" />
          </div>
        </div>
      </div>
      <div class="right-column">
        <c-box-chart
          :color="color"
          :data="chartData"
          :fill="chartFill"
          :height="chartHeight"
          :loading="chartLoading"
          :smooth="chartSmooth"
          :step-x="chartStepX"
          :step-y="chartStepY"
          :type="chartType"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CBoxChart from './CBoxChart.vue'
import CSpinner from '../../../../../../../resources/js/components/ui/CSpinner.vue'

export default {
  name: 'CStatsRow',
  components: {
    CSpinner,
    CBoxChart
  },
  props: {
    chartData: {
      type: Object,
      default: () => {
        return {
          labels: [],
          charts: []
        }
      }
    },
    chartFill: {
      type: Boolean,
      default: false
    },
    chartHeight: {
      type: [Number, undefined],
      default: undefined
    },
    chartLoading: {
      type: Boolean,
      default: false
    },
    chartSmooth: {
      type: Boolean,
      default: false
    },
    chartStepX: {
      type: [Number, undefined],
      default: undefined
    },
    chartStepY: {
      type: [Number, undefined],
      default: undefined
    },
    chartType: {
      type: [String, undefined],
      default: undefined
    },
    color: {
      type: String,
      default: '#808080'
    },
    total: {
      type: [Number, String],
      default: 0
    },
    totalsLoading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../../../../../resources/css/variables';

.c-stats-row {
  .wrapper {
    display: flex;
    @media all and (max-width: $smBreakpoint - 1) {
      display: block;
    }
    & > .left-column {
      width: 35%;
      @media all and (max-width: $smBreakpoint - 1) {
        width: 100%;
      }
    }
    & > .right-column {
      width: 100%;
    }
    & > .left-column + .right-column {
      padding-left: 14px;
      @media all and (max-width: $smBreakpoint - 1) {
        padding-left: 0;
      }
    }
    & > .left-column .my-box-wrapper,
    & > .right-column .my-box-wrapper {
      padding-bottom: 20px;
      height: 100%;
    }
    & > .left-column .my-box {
      position: relative;
      padding: 20px 30px;
      height: 100%;
      background-color: #fff;
      border-radius: $borderRadiusLarge;
      box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
      @media all and (max-width: $mdBreakpoint - 1) {
        padding: 20px;
      }
      & > .my-box-header {
        padding-bottom: 14px;
        & > span {
          font-size: 18px;
          color: #8aa4af;
          @media all and (max-width: $mdBreakpoint - 1) {
            font-size: 14px;
          }
        }
      }
      & > .my-box-body {
        & > span {
          font-size: 50px;
          font-weight: 700;
          @media all and (max-width: $mdBreakpoint - 1) {
            font-size: 32px;
          }
        }
      }
      & > .fa-spin {
        position: absolute;
        display: block;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 20px;
        height: 20px;
        font-size: 20px;
        line-height: 1;
      }
    }
  }
}
</style>
